import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { resolveImg } from "@/lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [regLinks, setRegLinks] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const [s, r] = await Promise.all([
        api.get("/settings"),
        api.get("/registration-links"),
      ]);
      setSettings(s.data || {});
      setRegLinks(r.data || []);
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Sync browser tab icon (favicon) with the official school logo
  useEffect(() => {
    const href = resolveImg(settings.logo_url);
    if (!href) return;
    ["icon", "apple-touch-icon"].forEach((rel) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    });
  }, [settings.logo_url]);

  const activeReg = regLinks.find((r) => r.is_active) || regLinks[0] || null;

  return (
    <SiteContext.Provider value={{ settings, regLinks, activeReg, refresh }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
